/**
 * Wrapper for tailwind-scrollbar-hide plugin to fix ES module compatibility issues
 */

// Import the plugin's functionality directly
const scrollbarHidePlugin = function ({ addUtilities }: { addUtilities: any }) {
  return addUtilities({
    ".scrollbar-hide": {
      /* IE and Edge */
      "-ms-overflow-style": "none",
      /* Firefox */
      "scrollbar-width": "none",
      /* Safari and Chrome */
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    ".scrollbar-default": {
      /* IE and Edge */
      "-ms-overflow-style": "auto",
      /* Firefox */
      "scrollbar-width": "auto",
      /* Safari and Chrome */
      "&::-webkit-scrollbar": {
        display: "block",
      },
    },
  });
};

export default scrollbarHidePlugin;
